(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(!e.isIntersecting||!v.paused)return;if(v.networkState===0||v.networkState===3)v.load();v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});});},{threshold:0.2});var q=0;function scan(){q=0;document.querySelectorAll('.product-media video[autoplay]').forEach(function(v){if(v.dataset.ap)return;v.dataset.ap='1';v.loop=true;v.muted=true;io.observe(v);});}scan();new MutationObserver(function(){if(!q)q=requestAnimationFrame(scan);}).observe(document.documentElement,{childList:true,subtree:true});})();
  } catch(e) { console.error(e); }
})();

})();
